import { render, staticRenderFns } from "./CloudDriveInvite.vue?vue&type=template&id=b21ea08a&scoped=true"
import script from "./CloudDriveInvite.vue?vue&type=script&lang=js"
export * from "./CloudDriveInvite.vue?vue&type=script&lang=js"
import style0 from "./CloudDriveInvite.vue?vue&type=style&index=0&id=b21ea08a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b21ea08a",
  null
  
)

export default component.exports